import React, { Component } from 'react';

import Clusters from './ClustersComponent'
import ClusterPanel from './ClusterPanel'
import { actions } from './ClustersReducer'
import { connect } from 'react-redux'

const mapClusterPanelStateToProps = (state, ownProps) => {
    return {
        devices_info: state.waas.clusters.clusters.devices_info[ownProps.clusterId] || {},
    }
}

const mapClusterPanelDispatchToProps = (dispatch, ownProps) => {
    return {
        getDeviceinfo: () => dispatch(actions.getDevicesInfo(ownProps.clusterId)),
    }
}

export const ConnectClusterPanel = connect(mapClusterPanelStateToProps, mapClusterPanelDispatchToProps)(ClusterPanel)

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
        this.props.getTrafficManagersInfo();
    }
    
    render() {
        return (
            <React.Fragment>
                <Clusters {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        fetcher: state.waas.clusters.fetcher,
        clustersDict: state.waas.clusters.fetcher.items || [],
        traffic_managers_info: state.waas.clusters.clusters.traffic_managers_info || {},
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: () => dispatch(actions.trigger()),
        reload: () => { dispatch(actions.trigger()); dispatch(actions.getTrafficManagersInfo()); },
        getTrafficManagersInfo: () => dispatch(actions.getTrafficManagersInfo()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)